import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchSchemeList } from "../customerSchemeApi";
import "../CustomerScheme.css";

const valueOrDash = (value) => (value === undefined || value === null || value === "" ? "-" : value);

const SchemeSelection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [schemes, setSchemes] = useState([]);
  const [schemeType, setSchemeType] = useState("ALL");

  const handleLogout = () => {
    sessionStorage.removeItem("customer_scheme_auth");
    localStorage.removeItem("customer_scheme_auth");
    navigate("/customer/login");
  };

  useEffect(() => {
    const loadSchemes = async () => {
      try {
        setLoading(true);
        const response = await fetchSchemeList();
        const list = response?.data?.data || response?.data || [];
        setSchemes(Array.isArray(list) ? list : []);
        setError("");
      } catch (err) {
        setError(err?.response?.data?.message || "Unable to fetch schemes.");
      } finally {
        setLoading(false);
      }
    };

    loadSchemes();
  }, []);

  const filteredSchemes = useMemo(() => {
    if (schemeType === "ALL") {
      return schemes;
    }
    return schemes.filter((scheme) => (scheme?.type || "").toUpperCase() === schemeType);
  }, [schemeType, schemes]);

  const selectScheme = (scheme) => {
    navigate("/customer/enroll", { state: { scheme } });
  };

  return (
    <div className="customer-scheme-shell">
      <div className="customer-scheme-container">
        <div className="customer-header">
          <div>
            <h2>Scheme Selection</h2>
            <p className="customer-subtitle">Choose COMBO, INDIVIDUAL, or SAVINGS SCHEME and continue.</p>
          </div>
          <div className="customer-row">
            <button className="customer-btn customer-btn-secondary" onClick={() => navigate("/customer/dashboard")}>Back to Dashboard</button>
            <button className="customer-btn customer-btn-secondary" onClick={handleLogout}>Logout</button>
          </div>
        </div>

        <div className="customer-card">
          <div className="customer-row">
            <button
              className={`customer-btn ${schemeType === "COMBO" ? "customer-btn-primary" : "customer-btn-secondary"}`}
              onClick={() => setSchemeType("COMBO")}
            >
              COMBO
            </button>
            <button
              className={`customer-btn ${schemeType === "INDIVIDUAL" ? "customer-btn-primary" : "customer-btn-secondary"}`}
              onClick={() => setSchemeType("INDIVIDUAL")}
            >
              INDIVIDUAL
            </button>
            <button
              className={`customer-btn ${schemeType === "OPEN_VALUE" ? "customer-btn-primary" : "customer-btn-secondary"}`}
              onClick={() => setSchemeType("OPEN_VALUE")}
            >
              SAVINGS SCHEME
            </button>
            <button
              className={`customer-btn ${schemeType === "ALL" ? "customer-btn-primary" : "customer-btn-secondary"}`}
              onClick={() => setSchemeType("ALL")}
            >
              ALL
            </button>
          </div>

          {loading ? (
            <div style={{ marginTop: 14 }}>Loading schemes...</div>
          ) : error ? (
            <div className="customer-error" style={{ marginTop: 14 }}>{error}</div>
          ) : (
            <div className="customer-scheme-list">
              {filteredSchemes.length === 0 ? (
                <div>No schemes found for selected type.</div>
              ) : (
                filteredSchemes.map((scheme) => (
                  <div className="customer-scheme-card" key={scheme?._id || scheme?.id || scheme?.name}>
                    <h4 className="customer-scheme-title">{scheme?.name || "Scheme"}</h4>
                    <p>Type: <strong>{valueOrDash(scheme?.type)}</strong></p>
                    <p>EMI: Rs. {scheme?.emiAmount || scheme?.emi || 0}</p>
                    <p>Duration: {scheme?.duration || "11 months"}</p>
                    <p>Gift: {valueOrDash(scheme?.gift)}</p>
                    <button className="customer-btn customer-btn-primary" onClick={() => selectScheme(scheme)}>Select Plan</button>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SchemeSelection;
